import Vue from 'vue'
import map_info_content from './map_info_content.vue'
let mapInfoContent = Vue.extend(map_info_content);
let  mapInfoContentVue={};
let initInstance = (data,map,type) => {
    //实例化ConfirmConstructor组件
    mapInfoContentVue = new mapInfoContent({
        el: document.createElement('div')
    });
    mapInfoContentVue.data=data;
    mapInfoContentVue.map=map;
    mapInfoContentVue.type=type;

    //添加到boby
    // console.log(mapInfoContentVue)
    return mapInfoContentVue.$el;
}

export default {
    createInfoWindow(data,map,type){
        return  initInstance(data,map,type);
    }
}



// WEBPACK FOOTER //
// ./src/page/main_content/map/baseMap/info_window.js